import { CompanySettings } from "@elton/types";
import { getServicesClient } from "@/api/clients/api-client.ts";

export const getCompanySettings = async (companyId: string) => {
  const res = await getServicesClient().get<CompanySettings>(`/companies/${companyId}/settings`);

  return res.data;
};
